import { useEffect, useState } from "react";
import api from "../api/axios";

export const WA_UNREAD_EVENT = "wa-unread-refresh";

/** Количество непрочитанных входящих WhatsApp (опрос раз в 15 секунд + мгновенно по событию из чата) */
export function useWaUnread(): number {
  const [n, setN] = useState(0);

  useEffect(() => {
    let alive = true;
    const load = () => {
      if (!localStorage.getItem("token")) return;
      api
        .get<{ unread: number }>("/whatsapp/unread")
        .then(r => alive && setN(r.data.unread || 0))
        .catch(() => {});
    };
    load();
    const t = setInterval(load, 15000);
    window.addEventListener(WA_UNREAD_EVENT, load);
    return () => {
      alive = false;
      clearInterval(t);
      window.removeEventListener(WA_UNREAD_EVENT, load);
    };
  }, []);

  return n;
}
